/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Importance of a compliance item.
 */
export enum ForOwnWorkflowType {
    OWN = 'Own',
    OTHERS = 'Others',
    NA = 'NA',
}
